import type { CreateInitialGroup } from '@quromedical/models';
import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type { FormikErrors } from 'formik';
import { clinicalGroupFetcher } from 'integration';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

interface PractitionerCreateInitialGroupFormProps {
  onValidChange: (data?: CreateInitialGroup) => void;
  showErrors: boolean;
}

const fields: Field<CreateInitialGroup>[] = [
  {
    subfields: [
      {
        type: 'combobox-single',
        searchable: true,
        label: 'Group',
        key: 'group',
        fetcher: clinicalGroupFetcher,
      },
    ],
  },
];

export const PractitionerCreateInitialGroupForm: React.FC<
  PractitionerCreateInitialGroupFormProps
> = ({ onValidChange, showErrors }) => {
  const onChange = useCallback(
    (
      data: Partial<CreateInitialGroup>,
      _: FormikErrors<CreateInitialGroup>,
      hasErrors: boolean,
    ) => {
      if (hasErrors) {
        onValidChange(undefined);
      } else {
        // casting since data is validated
        const result = data as CreateInitialGroup;

        onValidChange(result);
      }
    },
    [onValidChange],
  );

  return (
    <CrudForm
      title={strings.FormTitlePractitionerInitialGroup}
      fields={fields}
      initialValues={{}}
      onChange={onChange}
      showErrors={showErrors}
      validateOnMount
      showSubmitButton={false}
      hasCard={false}
    />
  );
};
